export enum LayerLogic {
  most_severe,
  quantitative
}
